import { ChainsListPageLayout } from '../ChainsListPageLayout';
import { ChainsListPageTitle } from '../ChainsListPageTitle';
import { ChainsSkeleton } from '../ChainsSkeleton';

export const ChainsListPageSkeleton = () => (
  <ChainsListPageLayout>
    <ChainsListPageTitle />
    <ChainsSkeleton />
  </ChainsListPageLayout>
);
